import React from 'react';
import Card from '../../../components/ACS-Dashboard/ACS-Blocks/Card';
import ScrollableContainer from '../../../components/ACS-Dashboard/ACS-Blocks/ScrollableContainer';

const ShipmentsList = ({ isCollapsed }) => {
  // Sample data for the scrollable cards
  const cardsData = [
    { title: "Delivered Shipments", percentage: "+10%", comparisonText: "vs last week", mainValue: "25", buttonText: "View" },
    { title: "In-transit Shipments", percentage: "+5%", comparisonText: "vs yesterday", mainValue: "15", buttonText: "Track" },
    { title: "Partially Shipped Orders", percentage: "-2%", comparisonText: "vs last month", mainValue: "8", buttonText: "Resolve" },
    { title: "Delayed Shipments", percentage: "-1%", comparisonText: "vs last month", mainValue: "3", buttonText: "Check" },
    { title: "Backordered Items", percentage: "+7%", comparisonText: "vs last week", mainValue: "12", buttonText: "View" },
    { title: "Upcoming Deliveries", percentage: "+5%", comparisonText: "vs next week", mainValue: "18", buttonText: "Plan" },
    { title: "Exceptions Flagged", percentage: "+7%", comparisonText: "vs last month", mainValue: "20", buttonText: "Review" }
  ];

  return (
    <div className="p-fluid-1 bg-color-custom-bg-purple">
      <ScrollableContainer direction="x" className="scrollbar-none">
        <div className="flex gap-[clamp(0.5rem,1cqw,1rem)]">
          {cardsData.map((card, index) => (
            <div 
              key={index} 
              className="scroll-snap-align-start"
              style={{ 
                minWidth: 'clamp(12rem,30cqw,11rem)',
                flex: '0 0 auto'
              }}
            >
              <Card 
                {...card}
                className="p-fluid-1.5"
                titleClassName="text-fluid-lg"
                valueClassName="text-fluid-xl"
                metaClassName="text-fluid-sm"
              />
            </div>
          ))}
        </div>
      </ScrollableContainer>
    </div>
  );
};

export default ShipmentsList;
